export enum SourceOption {
  DefaultValue = 'DefaultValue',
  ODSPerson = 'ODS.Person',
  ODSEmployee = 'ODS.Employee',
  PostData = 'PostData'
}